import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider, IconButton,
    keyframes,
    styled,
    Typography
} from "@mui/material";
import {FlexBox} from "./customStyledComponent";
import React, {ReactNode} from "react";
import {Breakpoint} from "@mui/system/createTheme/createBreakpoints";
import {DialogProps} from "@mui/material/Dialog";
import {CloseIcon} from "@contents/components/Icons";


const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(50px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const ModalHeader = styled(FlexBox)(({ theme }) => ({
    alignContent: "center",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "16px",
    fontWeight: "bold",
    color: theme.palette.eliga_42C.main,
}));

interface ModalCompType extends DialogProps {
    title?: string;
    titleNode?: ReactNode;
    headerRightComponent?: ReactNode;
    titleRightComponent?: ReactNode;
    children?: ReactNode;
    buttonComponent?: ReactNode;
    open: boolean;
    onClose?: () => void;
    maxWidth?: Breakpoint;
    customContent?: boolean;
    disableBackdropClick?: boolean;
    disableEscapeKeyDown?: boolean;
    isMobile?: boolean;
}

const ModalComp = ({
                       title,
                       titleNode,
                       headerRightComponent,
                       titleRightComponent,
                       children,
                       buttonComponent,
                       open = false,
                       onClose,
                       maxWidth = 'md',
                       customContent = false,
                       disableBackdropClick = false,
                       disableEscapeKeyDown = false,
                       isMobile = false,
                       ...rest
                   }: ModalCompType) => {

    const handleClose = () => {
        if(onClose) {
            onClose();
        }
    }

    const handleScroll = (e) => {
        rest.onScroll && rest.onScroll(e);
    }

    return (
        <Dialog open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={maxWidth}
                disableEscapeKeyDown={disableEscapeKeyDown}
                {...rest}
        >
            <DialogTitle>
                <ModalHeader>
                    {title && <Typography variant={'subtitle1'}>{title}</Typography>}
                    {titleNode && titleNode}
                    {isMobile && (
                        <FlexBox alignItems={'center'} gap={'20px'}>
                            {titleRightComponent && titleRightComponent}
                            <IconButton aria-label="delete" onClick={handleClose} sx={{width: '18px', height: '18px'}} >
                                <CloseIcon sx={{ fill: 'currentColor', color: 'black' }} />
                            </IconButton>
                        </FlexBox>
                    )}
                    {(!isMobile && titleRightComponent) && titleRightComponent}
                </ModalHeader>
            </DialogTitle>
            <Divider orientation="horizontal" flexItem  />
            {customContent ? children
                : <DialogContent onScroll={handleScroll}>{children}</DialogContent>
            }
            {buttonComponent && <DialogActions>{buttonComponent}</DialogActions>}
        </Dialog>
    )
};

export default ModalComp;
